import { render, staticRenderFns } from "./SavedFormLookup.vue?vue&type=template&id=c528334a&"
import script from "./SavedFormLookup.vue?vue&type=script&lang=js&"
export * from "./SavedFormLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports